export { default } from './ClassroomsSimpleItem';
